import InputRadio from "./input-radio";

export { InputRadio };
